var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "base-settings" } },
    [
      _c("base-settings-menu-sidebar", {
        attrs: {
          "menu-groups": _vm.menuGroups,
          "active-menu-item-id": _vm.activeMenuItemId,
        },
        on: {
          "item-click": function ($event) {
            _vm.activeMenuItemId = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-area" },
        [_vm._t("default", null, { activeMenuItemId: _vm.activeMenuItemId })],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }